module.exports = __webpack_public_path__ + "67f12303a2dabff2094e4dabbc4cbbba.svg";